import {
  Component,
  OnInit,
  HostListener,
  OnDestroy,
  Injector,
  ViewChild,
  ElementRef, AfterViewInit, ChangeDetectorRef,
} from '@angular/core';
import { AppConfig } from '../../../app.config';
import { Router, ActivatedRoute, NavigationStart } from '@angular/router';
import { HelpersService } from '../../../services/helpers.service';
import { UserService } from '../../../services/user.service';
import { PartnerService } from '../../../services/partner.service';
import { PaymentService } from '../../../services/payment.service';
import { TechnicianService } from '../../../services/technician.service';
import { ProductsService } from '../../../services/products.service';
import { BroadcastService } from '../../../services/broadcast.service';
import { NotificationService } from '../../../services/notification.service';
import { ServiceRequestService } from '../../../services/servicerequest.service';
import { RentalsService } from '../../../services/rentals.service';
import { InsuranceService } from '../../../services/insurance.service';
import { CountriesService } from '../../../services/countries.service';
import { UpdateJobcardComponent } from '../../modals/update-jobcard/update-jobcard.component';
import { firstValueFrom, Subscription } from 'rxjs';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { RecordBikeSaleComponent } from '../../modals/record-bike-sale/record-bike-sale.component';
import { TranslateService } from '@ngx-translate/core';
import { MessageService } from 'primeng/api';
import { ConfirmationService } from 'primeng/api';
import { NewJobcardService } from '../../../services/new-jobcard.service';

import { Renderer2, Inject } from '@angular/core';
import { VersionCheckService } from '../../../services/version-check.service';
import { SessionCheckService } from '../../../services/session-check.service';
import moment from 'moment';

import { productFruits } from 'product-fruits';
import { ThemeService } from "../../../services/theme.service";
import { DomSanitizer, SafeResourceUrl, SafeUrl } from "@angular/platform-browser";
import { CommunicationService } from '../../../services/communication.service';
import { AuthenticationService } from 'src/app/services/authentication.service';
//import { SwPush } from "@angular/service-worker";

declare global {
  interface Window {
    beamer_config: any;
  }
}

const WORKSHOP = 'WORKSHOP';
const RENTALS = 'RENTALS';

@Component({
  selector: 'app-portal',
  templateUrl: './portal.component.html',
  styleUrls: ['./portal.component.scss'],
  providers: [MessageService],
})
export class PortalComponent implements OnInit, OnDestroy {
  @ViewChild('menuOpenLink') menuOpenLink: ElementRef;
  @ViewChild('posSyncStatusOpenRef') posSyncStatusOpenRef: ElementRef;
  @ViewChild('profileDropdownRef') profileDropdownRef: ElementRef;
  @ViewChild('notificationsMenuRef') notificationsMenuRef: ElementRef;

  public menuOpen = true;
  public dropMenuOpen = false;
  public notificationOpen = false;
  public userName: string = '';
  public profile: any = {};
  public partner: any = {};
  public partnerID: string = '';
  public menuItems: any = [];
  public adminMenuItems: any = [];
  public subscription: Subscription;
  public showShadow = false;
  public IsDev: boolean = this.appConfig.isDev();
  public profileDataLoaded: boolean = false;
  public activeProduct: string = WORKSHOP;

  public technicianServiceMenuItems: any = [];
  public shopAdminServiceMenuItems: any = [];
  public serviceLeadServiceMenuItems: any = [];
  public shopRideAdminMenuItems: any = [];

  public shopAdminRentalMenuItems: any = [];

  public notifications: any = [];
  public shops: any = [];
  public shopDropMenuOpen: boolean = false;
  public shopDropMenuOpenNew: boolean = false;
  public credits = 0;
  private mounted = true;
  public roles: any;
  public maxDropdownShops = 10;
  public paymentStatus: any = {};
  //The payment status describes ONE (partner, product) pair. Without recording which
  //pair, a response for the wrong store/vertical gates access to the right one - which
  //is what bounced users to manage-subscription after switching stores. null = unknown.
  private paymentStatusKey: string = null;
  private readonly USABLE_STATUSES = [1, 3, 4, 20, 50, 51];
  public hidePaymentAlert: boolean = false;

  public quoteMessages: number = 0;

  public serviceWorkerRegistration: ServiceWorkerRegistration;
  public hasActiveSubscription: boolean = false;
  public canSubscribeToNotifications: boolean = false;
  public countryData: any = {};
  public showProductPicker: boolean = false;

  public selectedReservation: any = {};
  public showRentalReservation: boolean = false;

  public posSyncStatusOpen = false;
  customCSSURL: SafeResourceUrl;

  public serviceIndicatorsDue: number = 0;
  public showServiceIndicatorsDue: boolean = false;
  public userOfShops = 0;
  public connectedPlatform: any = []
  public isConnectedToTextPlatform: boolean = false;
  scripts = [
    {
      id: 'hs-script-loader',
      src: '//js-eu1.hs-scripts.com/26326740.js',
      type: 'text/javascript',
    },
  ];

  constructor(
    public appConfig: AppConfig,
    public helpersService: HelpersService,
    public router: Router,
    public userService: UserService,
    public partnerService: PartnerService,
    public technicianService: TechnicianService,
    public productsService: ProductsService,
    public broadcastService: BroadcastService,
    public notificationService: NotificationService,
    public serviceRequest: ServiceRequestService,
    public modalService: NgbModal,
    public messageService: MessageService,
    private translate: TranslateService,
    public confirmationService: ConfirmationService,
    public insuranceService: InsuranceService,
    private renderer2: Renderer2,
    private versionCheckService: VersionCheckService,
    private sessionCheckService: SessionCheckService,
    private countriesService: CountriesService,
    private paymentService: PaymentService,
    private rentalsService: RentalsService,
    private changeDetector: ChangeDetectorRef,
    private themeService: ThemeService,
    private communicationService: CommunicationService,
    private newJobcardService: NewJobcardService,
    public route: ActivatedRoute,
    private sanitizer: DomSanitizer,
    private authenticationService: AuthenticationService
    //   @Inject(DOCUMENT) private _document,
    //todo (dcorbett check this)
  ) {
    let script = document.createElement('script');
    script.id = this.scripts[0].id;
    script.src = this.scripts[0].src;
    script.type = this.scripts[0].type;
    script.async = true;
    script.onload = () => {
      this.initializeHelpDesk();
    };
    document.getElementsByTagName('head')[0].appendChild(script);


    if (!helpersService.getPartnerData()) {
      helpersService.savePartnerData({});
    }
    this.subscription = this.broadcastService.getMessage().subscribe((data) => {
      let message = data.message;
      if (message && message.profile) {
        var profile = message.profile;

        profile.PartnerID = this.helpersService.getPartnerId();
        //profile.isTechnician = profile.TechnicianID > 0 ? true : false;
        //profile.isAdmin = !profile.isTechnician && profile.PartnerID > 0 ? true : false;

        var roles = profile.UserRoles.filter((x) => {
          return x.PartnerID > 0;
        });
        var shopRoles = roles
          .filter((x) => {
            return x.PartnerID === this.helpersService.getPartnerId();
          })
          .map((x) => {
            return x.RoleID;
          });
        

        profile.isTechnician = shopRoles.includes(1);
        profile.isAdmin =
          shopRoles.includes(2) ||
          profile.UserRoles.includes(3) ||
          this.profile.IsSuperUser;
        profile.isManager = shopRoles.includes(3);
        profile.isServiceLead = shopRoles.includes(9);
        profile.isShopRideAdmin = shopRoles.includes(10);

        this.helpersService.saveProfileData(profile);
        this.profile = profile;

        this.getUpdatedUserProfile();
      } else if (message && message.partner && message.partner.switchPartner) {
        var profile = this.helpersService.getProfileData();

        profile.PartnerID = this.helpersService.getPartnerId();
        var roles = profile.UserRoles.filter((x) => {
          return x.PartnerID > 0;
        });
        var shopRoles = roles
          .filter((x) => {
            return x.PartnerID === this.helpersService.getPartnerId();
          })
          .map((x) => {
            return x.RoleID;
          });

        profile.isTechnician = shopRoles.includes(1);
        profile.isAdmin =
          shopRoles.includes(2) ||
          profile.UserRoles.includes(3) ||
          profile.IsSuperUser;
        profile.isManager = shopRoles.includes(3);
        profile.isServiceLead = shopRoles.includes(9);
        profile.isShopRideAdmin = shopRoles.includes(10);
        this.helpersService.saveProfileData(profile);
        this.profile = profile;

        //Reset the previous store's vertical/status before reloading. Querying the
        //payment status here would use the NEW partner with the OLD vertical.
        this.partner = {};
        this.activeProduct = WORKSHOP;
        this.invalidatePaymentStatus();

        //Was this.ngOnInit() - re-entering it started another checkPartner() reload
        //watchdog chain, another notification poll, another window click listener and
        //another Beamer script tag on every switch, none of which ngOnDestroy reclaims.
        //getUpdatedUserProfile() reloads the data without the leak.
        this.getUpdatedUserProfile();
      } else if (message && message.payment) {
        this.getPartnerData();
      } else if (message && message.updateNotifications) {
        this.notificationService
          .getUnreadNotifications(this.profile.PartnerID)
          .subscribe((notifications) => {
            this.notifications = notifications.reverse();
          });
      } else if (message && message.reloadServiceIndicator) {
        this.getRentalServiceIndicatorsDue();
      }
    });


    versionCheckService.initVersionCheck();
    sessionCheckService.init();

    router.events.forEach((event: any) => {
      if (event instanceof NavigationStart) {
        this.routeToPricing(event.url);
      }
    });

    this.setUpCustomColors();
  }


  @HostListener('window:scroll', ['$event'])
  onWindowScroll() {
    let pos =
      (document.documentElement.scrollTop || document.body.scrollTop) +
      document.documentElement.offsetHeight;
    let max = document.documentElement.scrollHeight;

    if (pos == max) {
      this.showShadow = false;
    } else {
      this.showShadow = true;
    }
  }

  ngOnInit() {
    this.getUpdatedUserProfile();
    this.getProducts();
    this.updateNotificationBadge();
    this.productWebHook();
    const partner = this.helpersService.getPartnerData();
    this.partnerID = this.helpersService.getPartnerId();
    this.activeProduct = this.helpersService.getActiveProduct() || WORKSHOP;
    this.checkIfTextMessagePlatformConfigured();
    this.setUpCustomColors();
    //this.getPaymentStatus();
    window.beamer_config = {
      product_id: 'UlKtyicO22677', //DO NOT CHANGE: This is your product code on Beamer
      selector: '.beamer',
      user_email: this.profile.Email,
      user_id: this.profile.ID,
    };

    const s = this.renderer2.createElement('script');
    s.type = 'text/javascript';
    s.src = 'https://app.getbeamer.com/js/beamer-embed.js';
    s.text = ``;

    document.getElementsByTagName('body')[0].appendChild(s);

    this.roles = this.helpersService.getProfileInsuranceRoles();
    this.getShops();
    //try {
    //  this.generateInsuranceMenu();
    //  setInterval(() => { this.generateInsuranceMenu() }, 30000);
    //} catch (e) {
    //  this.logout();
    //}
    this.initiateSubscriptionServices();

    this.renderer2.listen('window', 'click', (e: Event) => {
      if (e.target !== this.menuOpenLink?.nativeElement) {
        this.shopDropMenuOpenNew = false;
      }

      if ((e.target != this.posSyncStatusOpenRef?.nativeElement) && (!this.posSyncStatusOpenRef?.nativeElement.contains(e.target))) {
        this.posSyncStatusOpen = false;
      }

      if ((e.target != this.profileDropdownRef?.nativeElement) && (!this.profileDropdownRef?.nativeElement.contains(e.target))) {
        this.dropMenuOpen = false;
      }

      if (
        e.target != this.notificationsMenuRef?.nativeElement &&
        !this.notificationsMenuRef?.nativeElement.contains(e.target)
      ) {
        this.notificationOpen = false;
      }


    });
    if (this.partner.createdDate == undefined) {
      this.partnerService.getPartnerDetail(this.partnerID).subscribe((partner) => {
        productFruits.init(
          this.appConfig.getProductFruitID(),
          'en',
          {
            username: this.partnerID,
            signUpAt: partner.createdDate == undefined ? partner.CreatedDate : partner.createdDate
          },
          {
            disableLocationChangeDetection: true,
          },
        );
      });
    }
    else {
      productFruits.init(
        this.appConfig.getProductFruitID(),
        'en',
        {
          username: this.partnerID,
          signUpAt: this.partner.createdDate == undefined ? this.partner.CreatedDate : this.partner.createdDate
        },
        {
          disableLocationChangeDetection: true,
        },
      );
    }
    this.getCustomCss()

  }

  getCustomCss() {
    this.themeService.getOverrideCss(this.partnerID)
  }

  transform() {
    var env = this.appConfig.getEnvironmentNew();
    setTimeout(() => {
    }, 1000);

    return this.sanitizer.bypassSecurityTrustResourceUrl(
      `${env.url}/Portal/OverrideCSS/${this.partnerID}?code=${env.key}`,
    );
  }

  openSyncMenu(event: Event) {
    this.posSyncStatusOpen = !this.posSyncStatusOpen
    event.stopPropagation();
  }

  openProfileMenu(event: Event) {
    this.dropMenuOpen = !this.dropMenuOpen
    event.stopPropagation();
  }

  openNotificationsMenu(event: Event) {
    this.notificationOpen = !this.notificationOpen
    event.stopPropagation();
  }

  getShops() {
    this.userService.getConnectedBikeShops().subscribe((partners) => {
      this.shops = partners;
    });
  }

  ngOnDestroy(): void {
    this.mounted = false;
    window.beamer_config = null;
    if (this.rentalServiceIndicatorsTimeout) {
      clearTimeout(this.rentalServiceIndicatorsTimeout);
      this.rentalServiceIndicatorsTimeout = null;
    }
  }

  onConfirm() {
    this.messageService.clear('global_toast');
    setTimeout(() => {
      location.reload();
    }, 500);
  }

  onReject() {
    this.messageService.clear('global_toast');
  }

  selectShop(partner) {
    //Point at the new store FIRST: getPartnerId() reads PartnerID off this same
    //profile blob, and clearTenantScopedCache() must not touch it.
    var profile = this.helpersService.getProfileData();
    profile.PartnerID = partner.ID;
    this.helpersService.saveProfileData(profile);

    this.helpersService.clearTenantScopedCache();

    //Reset in-memory state too, so nothing can resolve a vertical from store A.
    this.partner = {};
    this.activeProduct = WORKSHOP;
    this.invalidatePaymentStatus();

    //Park on the vertical-neutral spinner route: it is in neither routeToPricing
    //whitelist, and carries no '/rentals/' for the URL sniffers to latch onto.
    this.router.navigateByUrl('store/product-redirect-loader');

    //This is the login path. getUpdatedUserProfile() re-fetches roles for the new
    //store, then getPartnerData() -> setActiveProduct(true) resolves the vertical
    //from the NEW SubscribedProducts, navigates to that vertical's default screen,
    //and queries payment status for the right product.
    this.getUpdatedUserProfile();
  }

  checkProfileShop(shopID) {
    var profile = this.helpersService.getProfileData();
    if (profile.PartnerID == shopID) {
      return true;
    }
    return false;
  }

  generateMenus() {
    const partner = this.helpersService.getPartnerData();
    this.userOfShops = this.profile.UserRoles.filter((x) => {
      return [1, 2, 3, 4, 9, 10].indexOf(x.RoleID) > -1;
    })
      .map((x) => {
        return x.PartnerID;
      })
      .filter((value, index, self) => {
        return self.indexOf(value) === index;
      }).length;

    this.technicianServiceMenuItems = [
      {
        label: 'Quicklinks',
        separator: true,
        items: [
          {
            id: 'menu-services',
            label: this.translate.instant('bikeshop.menu.services'),
            icon: 'garage',
            routerLink: ['/store/services'],
            classId: 'menu-services',
            command: () => {
              this.closeMenu();
            },
          },
          {
            id: 'menu-calendar',
            label: this.translate.instant('bikeshop.menu.calendar'),
            icon: 'calendar',
            classId: 'menu-calendar',
            routerLink: ['/store/calendar'],
            command: () => {
              this.closeMenu();
            },
          },
          {
            id: 'menu-notifications',
            label: this.translate.instant(
              'bikeshop.menu.incoming_notifications',
            ),
            icon: 'message-circle',
            classId: 'menu-notifications',
            routerLink: ['/store/job-card-messages'],
            command: () => {
              this.closeMenu();
            },
          },
          this.userOfShops >= this.maxDropdownShops ||
            this.shops.length >= this.maxDropdownShops
            ? {
              id: 'menu-switch-shop',
              label: this.translate.instant('bikeshop.menu.switch_shop'),
              icon: 'building',
              classId: 'menu-switch-shop',
              routerLink: ['/store/switch-shop'],
              command: () => {
                this.closeMenu();
              },
            }
            : {
              id: 'menu-special-orders',
              label: 'Special Orders', //this.translate.instant('bikeshop.menu.bike_sale'),
              classId: 'menu-special-orders',
              separator: true,
            },
          partner.POSSystemID === 6 && partner.RequestOrder
            ? {
              id: 'menu-special-orders',
              label: this.translate.instant('bikeshop.menu.special_orders'),
              icon: 'treasure-chest',
              classId: 'menu-special-orders',
              routerLink: ['/store/special-orders'],
              command: () => {
                this.closeMenu();
              },
            }
            : {
              label: 'Special Orders', //this.translate.instant('bikeshop.menu.bike_sale'),
              separator: true,
            },
          {
            id: 'help',
            label: this.translate.instant(
              'general.help',
            ),
            icon: 'play',
            classId: 'p-menuitem-link help-video-button',
            //routerLink: ['https://hubtiger.referral-factory.com/JLZhSV/join'],
            command: () => {
              this.helpSubMenu = !this.helpSubMenu;
            },
          },
          {
            id: 'refer_and_earn',
            label: this.translate.instant(
              'general.refer_and_earn',
            ),
            icon: 'message-heart',
            classId: 'p-menuitem-link help-video-button',
            //routerLink: ['https://hubtiger.referral-factory.com/JLZhSV/join'],
            command: () => {
              this.openReferrals();
            },
          },
        ],
      },
    ];

    this.shopAdminServiceMenuItems = [
      {
        label: 'Quicklinks',
        separator: true,
        items: [
          {
            id: 'menu-dashboard',
            label: this.translate.instant('bikeshop.menu.dashboard'),
            icon: 'house-line',
            classId: 'menu-dashboard',
            routerLink: ['/store/dashboard'],
            command: () => {
              this.closeMenu();
            },
          },
          {
            id: 'menu-services',
            label: this.translate.instant('bikeshop.menu.services'),
            icon: 'single-person',
            classId: 'menu-services',
            routerLink: ['/store/services'],
            command: () => {
              this.closeMenu();
            },
          },
          {
            id: 'menu-calendar',
            label: this.translate.instant('bikeshop.menu.calendar'),
            icon: 'calendar',
            classId: 'menu-calendar',
            routerLink: ['/store/calendar'],
            command: () => {
              this.closeMenu();
            },
          },
          {
            id: 'menu-services-kanban',
            label: 'Services Kanban',
            icon: 'kanban',
            classId: 'menu-services-kanban',
            routerLink: ['/bikeshop/workshop-services-kanban'],
            command: () => {
              this.closeMenu();
            },
          },
          this.profile && this.profile.isAdmin
            ? {
              id: 'menu-reports',
              label: this.translate.instant('bikeshop.menu.reports'),
              icon: 'report',
              classId: 'menu-reports',
              routerLink: ['/store/reports'],
              command: () => {
                this.closeMenu();
              },
            }
            : {
              id: 'menu-reports',
              label: this.translate.instant('bikeshop.menu.reports'),
              classId: 'menu-reports',
              separator: true,
            },
          {
            id: 'menu-customers',
            label: this.translate.instant('bikeshop.menu.cyclists'),
            icon: 'people',
            classId: 'menu-cyclists',
            routerLink: ['/store/customers'],
            command: () => {
              this.closeMenu();
            },
          },
          {
            id: 'menu-pick-ups',
            label: this.translate.instant('bikeshop.menu.pick_ups'),
            icon: 'truck',
            classId: 'menu-pick-ups',
            routerLink: ['/store/collections'],
            command: () => {
              this.closeMenu();
            },
          },
          {
            id: 'menu-settings',
            label: this.translate.instant('bikeshop.menu.settings'),
            icon: 'settings-gear',
            classId: 'menu-settings',
            routerLink: ['/store/shop-setup'],
            command: () => {
              this.closeMenu();
            },
          },

          {
            id: 'menu-notifications',
            label: this.translate.instant(
              'bikeshop.menu.incoming_notifications',
            ),
            icon: 'bell',
            classId: 'menu-incoming-notifications',
            routerLink: ['/store/job-card-messages'],
            command: () => {
              this.closeMenu();
            },
          },

          this.partner.PartnerType === 1 &&
            (partner.POSSystemID <= 0 || [0, 1, 12].includes(partner.POSSystemID))
            ? {
              id: 'menu-bike-sale',
              label: this.translate.instant('bikeshop.menu.bike_sale'),
              icon: 'shopping-cart',
              classId: 'menu-bike-sale',
              command: () => {
                const modalRef = this.modalService.open(
                  RecordBikeSaleComponent,
                  {
                    size: 'lg',
                    backdrop: 'static',
                    windowClass: 'bike-sale-modal',
                  },
                );
                modalRef.componentInstance.partnerId = this.profile.PartnerID;
                modalRef.componentInstance.messageService =
                  this.messageService;
              },
            }
            : {
              label: this.translate.instant('bikeshop.menu.special_orders'),
              id: 'menu-special-orders',
              classId: 'menu-special-orders',
              separator: true,
            },
          partner.POSSystemID === 6 && partner.RequestOrder
            ? {
              label: this.translate.instant('bikeshop.menu.special_orders'),
              id: 'menu-special-orders',
              icon: 'treasure-chest',
              classId: 'menu-special-orders',
              routerLink: ['/store/special-orders'],
              command: () => {
                this.closeMenu();
              },
            }
            : {
              label: 'Special Orders', //this.translate.instant('bikeshop.menu.bike_sale'),
              id: 'menu-special-orders',
              classId: 'menu-special-orders',
              separator: true,
            },
          this.userOfShops >= this.maxDropdownShops ||
            this.shops.length >= this.maxDropdownShops
            ? {
              id: 'menu-switch-shop',
              label: this.translate.instant('bikeshop.menu.switch_shop'),
              icon: 'building',
              classId: 'menu-switch-shop',
              routerLink: ['/store/switch-shop'],
              command: () => {
                this.closeMenu();
              },
            }
            : {
              label: 'Special Orders', //this.translate.instant('bikeshop.menu.bike_sale'),
              classId: 'menu-special-orders',
              separator: true,
            },
          this.partner.PartnerType === 1
            ? {
              id: 'menu-community',
              label: this.translate.instant('bikeshop.menu.community'),
              icon: 'heart',
              classId: 'menu-community',
              routerLink: ['/store/community'],
              command: () => {
                this.closeMenu();
              },
            }
            : {
              label: this.translate.instant('bikeshop.menu.community'),
              classId: 'menu-community',
              separator: true,
            },

          {
            id: 'help',
            label: this.translate.instant(
              'general.help',
            ),
            icon: 'play',
            classId: 'p-menuitem-link help-video-button',
            //routerLink: ['https://hubtiger.referral-factory.com/JLZhSV/join'],
            command: () => {
              this.helpSubMenu = !this.helpSubMenu;
            },
          },
          {
            id: 'refer_and_earn',
            label: this.translate.instant(
              'general.refer_and_earn',
            ),
            icon: 'message-heart',
            classId: 'p-menuitem-link help-video-button',
            //routerLink: ['https://hubtiger.referral-factory.com/JLZhSV/join'],
            command: () => {
              this.openReferrals();
            },
          },
          //,
          // {
          //   label: this.translate.instant("bikeshop.menu.help"),
          //   icon: "fa fa-fw hubtiger-tooltip",
          //   command: () => {
          //     window.open('https://help.hubtiger.com', '_blank');
          //   }
          // }
        ],
      },
    ];

    this.serviceLeadServiceMenuItems = [
      {
        label: 'Quicklinks',
        separator: true,
        items: [
          {
            id: 'menu-dashboard',
            label: this.translate.instant('bikeshop.menu.dashboard'),
            icon: 'house-line',
            classId: 'menu-dashboard',
            routerLink: ['/store/dashboard'],
            command: () => {
              this.closeMenu();
            },
          },
          {
            id: 'menu-services',
            label: this.translate.instant('bikeshop.menu.services'),
            icon: 'single-person',
            classId: 'menu-services',
            routerLink: ['/store/services'],
            command: () => {
              this.closeMenu();
            },
          },
          {
            id: 'menu-calendar',
            label: this.translate.instant('bikeshop.menu.calendar'),
            icon: 'calendar',
            classId: 'menu-calendar',
            routerLink: ['/store/calendar'],
            command: () => {
              this.closeMenu();
            },
          },
          {
            id: 'menu-customers',
            label: this.translate.instant('bikeshop.menu.cyclists'),
            icon: 'people',
            classId: 'menu-cyclists',
            routerLink: ['/store/customers'],
            command: () => {
              this.closeMenu();
            },
          },
          {
            id: 'menu-settings',
            label: this.translate.instant('bikeshop.menu.settings'),
            icon: 'settings-gear',
            classId: 'menu-settings',
            routerLink: ['/store/shop-setup'],
            command: () => {
              this.closeMenu();
            },
          },
          {
            id: 'menu-notifications',
            label: this.translate.instant(
              'bikeshop.menu.incoming_notifications',
            ),
            icon: 'bell',
            classId: 'menu-incoming-notifications',
            routerLink: ['/store/job-card-messages'],
            command: () => {
              this.closeMenu();
            },
          },          
          this.userOfShops >= this.maxDropdownShops ||
            this.shops.length >= this.maxDropdownShops
            ? {
              id: 'menu-switch-shop',
              label: this.translate.instant('bikeshop.menu.switch_shop'),
              icon: 'building',
              classId: 'menu-switch-shop',
              routerLink: ['/store/switch-shop'],
              command: () => {
                this.closeMenu();
              },
            }
            : {
              label: 'Switch Store', //this.translate.instant('bikeshop.menu.bike_sale'),
              classId: 'menu-switch-shop',
              separator: true,
            },
          {
            id: 'help',
            label: this.translate.instant(
              'general.help',
            ),
            icon: 'play',
            classId: 'p-menuitem-link help-video-button',
            //routerLink: ['https://hubtiger.referral-factory.com/JLZhSV/join'],
            command: () => {
              this.helpSubMenu = !this.helpSubMenu;
            },
          },
          //,
          // {
          //   label: this.translate.instant("bikeshop.menu.help"),
          //   icon: "fa fa-fw hubtiger-tooltip",
          //   command: () => {
          //     window.open('https://help.hubtiger.com', '_blank');
          //   }
          // }
        ],
      },
    ];

    this.shopRideAdminMenuItems = [
      {
        label: 'Quicklinks',
        separator: true,
        items: [
          {
            id: 'bikeshop_rides',
            label: this.translate.instant('bikeshop.community.bikeshop_rides'),
            icon: 'heart',
            classId: 'bikeshop_rides',
            routerLink: ['/store/shop-rides'],
            command: () => {
              this.closeMenu();
            },
          },
          {
            id: 'menu-settings',
            label: this.translate.instant('bikeshop.menu.settings'),
            icon: 'settings-gear',
            classId: 'menu-settings',
            routerLink: ['/store/shop-setup'],
            command: () => {
              this.closeMenu();
            },
          },
          this.userOfShops >= this.maxDropdownShops ||
            this.shops.length >= this.maxDropdownShops
            ? {
              id: 'menu-switch-shop',
              label: this.translate.instant('bikeshop.menu.switch_shop'),
              icon: 'building',
              classId: 'menu-switch-shop',
              routerLink: ['/store/switch-shop'],
              command: () => {
                this.closeMenu();
              },
            }
            : {
              label: 'Switch Store',
              classId: 'menu-switch-shop',
              separator: true,
            },
          {
            id: 'help',
            label: this.translate.instant('general.help'),
            icon: 'play',
            classId: 'p-menuitem-link help-video-button',
            command: () => {
              this.helpSubMenu = !this.helpSubMenu;
            },
          },
        ],
      },
    ];

    this.shopAdminRentalMenuItems = [
      // {
      //   label: this.translate.instant("bikeshop.menu.dashboard"),
      //   icon: "fa fa-fw hubtiger-dashboard",
      //   routerLink: ["/bikeshop/rentals/dashboard"],
      //   command: () => {
      //     this.closeMenu();
      //   },
      // },
      {
        id: 'menu-rentals',
        label: this.translate.instant('bikeshop.menu.reservation_calendar'),
        classId: 'menu-rentals',
        icon: 'calendar',
        routerLink: ['/store/rentals/reservations'],
        command: () => {
          this.closeMenu();
        },
      },
      {
        id: 'menu-rentals-summary',
        label: this.translate.instant(
          'bikeshop.shop_setup.header.reservation_summary',
        ),
        icon: 'clipboard',
        classId: 'menu-rentals-summary',
        routerLink: ['/store/rentals/reservations-summary'],
        command: () => {
          this.closeMenu();
        },
      },
      // {
      //   label: this.translate.instant("bikeshop.menu.reports"),
      //   icon: "fa fa-fw hubtiger-report",
      //   routerLink: ["/bikeshop/rentals/reports"],
      //   command: () => {
      //     this.closeMenu();
      //   },
      // },
      {
        id: 'menu-customers',
        label: this.translate.instant('bikeshop.menu.cyclists'),
        icon: 'people',
        classId: 'menu-cyclists',
        routerLink: ['/store/rentals/customers'],
        command: () => {
          this.closeMenu();
        },
      },
      {
        id: 'menu-reports',
        label: this.translate.instant('bikeshop.menu.reports'),
        icon: 'report',
        classId: 'menu-reports',
        routerLink: ['/store/rentals/reports'],
        command: () => {
          this.closeMenu();
        },
      },
      {
        id: 'menu-service-indicator-dashboard',
        label: this.translate.instant('bikeshop.menu.rentals_service_indicator_dashboard'),
        icon: 'chart-user-square',
        serviceIndicatorsDue: this.serviceIndicatorsDue,
        showServiceIndicatorsDue: this.showServiceIndicatorsDue,
        classId: 'menu-service-indicator-dashboard',
        routerLink: ['/store/rentals/service-indicator-dashboard'],
        command: () => {
          this.closeMenu();
        },
      },
      {
        id: 'menu-affiliates-commission',
        label: this.translate.instant('bikeshop.menu.affiliates_commission'),
        icon: 'building',
        classId: 'menu-affiliates-commission',
        routerLink: ['/store/rentals/affiliate-commission-payments'],
        command: () => {
          this.closeMenu();
        },
      },
      {
        id: 'menu-deliveries',
        label: this.translate.instant('bikeshop.menu.deliveries'),
        icon: 'truck',
        classId: 'menu-deliveries',
        routerLink: ['/store/rentals/deliveries'],
        command: () => {
          this.closeMenu();
        },
      },
      // {
      //   label: this.translate.instant("bikeshop.menu.incoming_notifications"),
      //   icon: "fa fa-fw hubtiger-no-notification",
      //   routerLink: ["/bikeshop/rentals/job-card-messages"],
      //   command: () => {
      //     this.closeMenu();
      //   }
      // },
      this.userOfShops >= this.maxDropdownShops ||
        this.shops.length >= this.maxDropdownShops
        ? {
          id: 'menu-switch-shop',
          label: this.translate.instant('bikeshop.menu.switch_shop'),
          icon: 'building',
          classId: 'menu-switch-shop',
          routerLink: ['/store/rentals/switch-shop'],
          command: () => {
            this.closeMenu();
          },
        }
        : {
          label: '',
          separator: true,
        },
      {
        id: 'menu-settings',
        label: this.translate.instant('bikeshop.menu.settings'),
        icon: 'settings-gear',
        classId: 'menu-settings',
        routerLink: ['/store/rentals/settings'],
        command: () => {
          this.closeMenu();
        },
      },
      {
        id: 'refer_and_earn',
        label: this.translate.instant(
          'general.refer_and_earn',
        ),
        icon: 'message-heart',
        classId: 'p-menuitem-link help-video-button',
        //routerLink: ['https://hubtiger.referral-factory.com/JLZhSV/join'],
        command: () => {
          this.openReferrals();
        },
      },
      {
        id: 'help',
        label: this.translate.instant(
          'general.help',
        ),
        icon: 'play',
        classId: 'p-menuitem-link help-video-button',
        //routerLink: ['https://hubtiger.referral-factory.com/JLZhSV/join'],
        command: () => {
          this.helpSubMenu = !this.helpSubMenu;
        },
      },
    ];

    /*try {
  
                                                                                                          var isInsurance = false;
                                                                                                          for (var i = 0; i < this.roles.users.length; i++) {
                                                                                                            if (this.roles.users[i].roleID === 5 || this.roles.users[i].roleID === 8)
                                                                                                              isInsurance = true;
                                                                                                          }
  
                                                                                                          if (this.roles != undefined && isInsurance) {
                                                                                                            this.shopAdminServiceMenuItems[0].items.splice(3, 0, {
                                                                                                              label: "Insurance Quotes",//this.translate.instant("bikeshop.menu.calendar"),
                                                                                                              icon: "fa fa-fw hubtiger-quote",
                                                                                                              badge: 10,
                                                                                                              styleClass: "notifyInsurance",
                                                                                                              routerLink: ["/bikeshop/insurance"],
                                                                                                              command: () => {
                                                                                                                this.closeMenu();
                                                                                                              }
                                                                                                            });
                                                                                                          }
  
                                                                                                        } catch (e) {
                                                                                                          this.logout();
                                                                                                        }    */
  }

  addSharedMenuItems() {
    if (this.menuItems.length === 0) return;
    if (this.menuItems[0].items === undefined) return;

    this.menuItems[0].items.push(
      {
        id: 'refer_and_earn',
        label: this.translate.instant(
          'general.refer_and_earn',
        ),
        icon: 'message-heart',
        classId: 'p-menuitem-link help-video-button',
        //routerLink: ['https://hubtiger.referral-factory.com/JLZhSV/join'],
        command: () => {
          this.openReferrals();
        },
      },
      {
        id: 'help',
        label: this.translate.instant(
          'general.help',
        ),
        icon: 'play',
        classId: 'p-menuitem-link help-video-button',
        //routerLink: ['https://hubtiger.referral-factory.com/JLZhSV/join'],
        command: () => {
          this.helpSubMenu = !this.helpSubMenu;
        },
      },
    )
  }
  generateInsuranceMenu() {
    var isInsurance = false;
    for (var i = 0; i < this.roles.users.length; i++) {
      if (this.roles.users[i].roleID === 5 || this.roles.users[i].roleID === 8)
        isInsurance = true;
    }

    const partner = this.helpersService.getPartnerData();
    if (partner && partner.ID && this.roles != undefined && isInsurance) {
      this.insuranceService
        .getInsuranceQuoteMessageStatus(partner.ID.toString())
        .subscribe((response) => {
          if (response != '') {
            this.quoteMessages = 0;
            var obj = JSON.parse(response);
            for (var i = 0; i < obj.Messages.length; i++) {
              if (obj.Messages[i].Status === 'UNREAD')
                this.quoteMessages = obj.Messages[i].Count;
            }
            if (this.quoteMessages > 0) {
              if (
                this.shopAdminServiceMenuItems != undefined &&
                this.shopAdminServiceMenuItems.length > 0
              )
                this.shopAdminServiceMenuItems[0].items[3].label =
                  'Insurance Quotes (' + this.quoteMessages + ')';

              //if (this.roles != undefined && (this.roles.roleID === 5 || this.roles.roleID === 8)) {
              //  this.shopAdminServiceMenuItems[0].items.splice(3, 0, {
              //    label: "Insurance Quotes (" + this.quoteMessages + ")",//this.translate.instant("bikeshop.menu.calendar"),
              //    icon: "fa fa-fw fa-book",
              //    styleClass: "notifyInsurance",
              //    routerLink: ["/bikeshop/insurance"],
              //    command: () => {
              //      this.closeMenu();
              //    }
              //  });
              //}
            }
          }
        });
    }
  }

  getProducts() {
    this.productsService
      .getAllProductsWithGear(this.helpersService.getPartnerId())
      .subscribe((products) => {
        this.helpersService.saveProductData(products);
      });
  }

  async getUpdatedUserProfile() {
    const localSorage = this.helpersService.getAuthData();
    if (localSorage && localSorage.username) {
      this.profile = this.helpersService.getProfileData();

      this.getPartnerTempData();
      this.getPartnerData();

      this.appConfig.setLocale(
        this.profile.Locale ? this.profile.Locale : 'en',
      );
      this.translate.setDefaultLang(
        (this.appConfig.getPartnerType() === 'bicycle'
          ? ''
          : this.appConfig.getPartnerType() + '/') +
        (this.profile.Locale ? this.profile.Locale : 'en'),
      );

      // Convert Observable to Promise so await actually works
      const profile = await firstValueFrom(
        this.userService.getUserDetail(this.profile.UserName)
      );

      this.profile.UserRoles = profile.UserRoles;
      const roles = this.profile.UserRoles.filter((x) => x.PartnerID > 0);
      const shopRoles = roles
        .filter((x) => x.PartnerID === this.helpersService.getPartnerId())
        .map((x) => x.RoleID);

      this.profile.isTechnician = shopRoles.includes(1) || shopRoles.includes(4);
      this.profile.isAdmin =
        shopRoles.includes(2) ||
        profile.UserRoles.includes(3) ||
        profile.IsSuperUser;
      this.profile.isManager = shopRoles.includes(3);
      this.profile.isServiceLead = shopRoles.includes(9);
      this.profile.isShopRideAdmin = shopRoles.includes(10);
      this.helpersService.saveProfileData(this.profile);
    } else {
      this.helpersService.removeTokenAndLogout();
      this.router.navigateByUrl('/');
    }
  }

  getPartnerTempData() {
    if (
      this.helpersService.getPartnerId() === 0 ||
      this.helpersService.getPartnerId() === null
    ) {
      this.router.navigate(['/'], {
        queryParams: {
          returnUrl: this.router.url,
        },
      });
    } else {
      this.partner = this.helpersService.getPartnerData();
      this.countryData = this.helpersService.getCountryData();

      //Nothing cached (fresh login, or we just switched store). Don't guess a vertical
      //from empty data and navigate somewhere wrong - getPartnerData() does both
      //properly once the new store's details arrive.
      if (!this.partner || !this.partner.ID) {
        return;
      }

      setTimeout(() => {
        this.appConfig.populateData(); //This is just to refresh some of the common lists used in the app, if the language changed, it will repopulate here.
        this.generateMenus();
        this.setActiveProduct();

        this.profileDataLoaded = true;
        this.checkPartner();
        this.setUpCustomColors();
      }, 1000); //Need a better way to do this but basically changing the language means the browser first has to download the language file, if its not done by the time this code executes, it will make the menus etc show the default language.
    }
  }

  setActiveProduct(loadPaymentStatus: boolean = false) {
    //One source of truth for the vertical. This used to re-derive it here with its own
    //copy of the [1,3,4,20,50,51] filter, which answers "which product can this store
    //USE" - not "which product does it OWN". For a store whose only product is expired
    //those differ, so the old code produced an empty list, fell into its else branch,
    //forced WORKSHOP, and then disagreed with resolveActiveProduct() a few lines later.
    const resolved = this.helpersService.resolveActiveProduct();
    this.activeProduct = resolved;
    this.helpersService.setActiveProduct(resolved);
    this.setBannerFromRow();

    //Based on products the store OWNS, not ones it can currently use, so a two-product
    //store with one lapsed vertical can still switch into it to resubscribe.
    const ownedProducts = this.productRows()
      .map((r) => {
        return r.type;
      })
      .filter((v, i, s) => {
        return s.indexOf(v) === i;
      });
    this.showProductPicker =
      (this.profile.isAdmin || this.profile.isManager) &&
      (ownedProducts.length > 1 || this.partner.StatusID == 51);

    if (resolved === WORKSHOP) {
      if (this.profile.isAdmin || this.profile.isManager) {
        this.menuItems = this.shopAdminServiceMenuItems;
      } else if (this.profile.isServiceLead) {
        this.menuItems = this.serviceLeadServiceMenuItems;
      } else if (this.profile.isShopRideAdmin) {
        this.menuItems = this.shopRideAdminMenuItems;
      } else if (this.profile.isTechnician) {
        this.menuItems = this.technicianServiceMenuItems;
      }
      if (
        this.router.url.toLocaleLowerCase().indexOf('store/rentals') > -1 ||
        this.router.url
          .toLocaleLowerCase()
          .indexOf('store/product-redirect-loader') > -1
      ) {
        if (this.profile.isTechnician) {
          this.router.navigateByUrl('store/calendar');
        } else {
          this.router.navigateByUrl('store/calendar');
        }
      }
    } else {
      this.menuItems = this.shopAdminRentalMenuItems;
      if (
        this.router.url.toLocaleLowerCase().indexOf('store/rentals') === -1
      ) {
        this.router.navigateByUrl('store/rentals/reservations');
      }
      this.getRentalServiceIndicatorsDue(true);
    }

    //Deliberately last: the vertical is final by now, so this can never query a
    //product the store doesn't have. Firing it before the branches above is what
    //asked for WORKSHOP on a rentals-only store and got the response discarded.
    if (loadPaymentStatus) {
      this.getPaymentStatus();
    }
  }

  getPartnerData() {
    if (
      this.helpersService.getPartnerId() === 0 ||
      this.helpersService.getPartnerId() === null
    ) {
      this.router.navigate(['/'], {
        queryParams: {
          returnUrl: this.router.url,
        },
      });
    } else {
      this.partnerService
        .getPartnerDetail(this.helpersService.getPartnerId())
        .subscribe({
          next: (result) => {
          this.partner = result;
          this.helpersService.savePartnerData(this.partner);
          this.translate.setDefaultLang(
            (this.appConfig.getPartnerType() === 'bicycle'
              ? ''
              : this.appConfig.getPartnerType() + '/') +
            (this.profile.Locale ? this.profile.Locale : 'en'),
          );
          this.countriesService
            .getAllCountry(this.partner.Country)
            .subscribe((country) => {
              country.DatePickerFormat = country.datePickerFormat;
              country.AngularDateFormat = country.angularDateFormat;
              country.MomentDateFormat = country.momentDateFormat;
              //Just here to test formats
              // country.DatePickerFormat = "mm/dd/yy";
              // country.AngularDateFormat = "MM/dd/yyyy";
              // country.MomentDateFormat = "MM/DD/YYYY";
              this.helpersService.saveCountryData(country);
              this.countryData = country;
            });

          setTimeout(() => {
            this.appConfig.populateData(); //This is just to refresh some of the common lists used in the app, if the language changed, it will repopulate here.
            //this.translate.setDefaultLang(this.appConfig.getPartnerType() + "/" + (this.profile.Locale ? this.profile.Locale : "en"));
            this.generateMenus();

            this.setActiveProduct(true);

            this.profileDataLoaded = true;
            this.checkPartner();
            this.setUpCustomColors();
          }, 1000); //Need a better way to do this but basically changing the language means the browser first has to download the language file, if its not done by the time this code executes, it will make the menus etc show the default language.
          },
          error: (err) => {
            //profileDataLoaded gates the <router-outlet>, and it is only ever set in
            //here and in getPartnerTempData(). Switching stores now clears the cached
            //partner data, so if this call fails there is nothing to fall back on and
            //the user would sit on a permanently blank page. Render the shell anyway
            //so they can navigate or reload rather than being stuck.
            console.error('Failed to load partner detail', err);
            this.profileDataLoaded = true;
            this.setUpCustomColors();
          },
        });
    }
  }

  setUpCustomColors() {
    try {
      if (this.partner.INeedHelpColor && this.partner.INeedHelpColor.length > 0) {
        var result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(
          this.partner.INeedHelpColor,
        );
        document.documentElement.style.setProperty(
          '--i-need-help-var',
          this.partner.INeedHelpColor,
        );
        document.documentElement.style.setProperty(
          '--i-need-help-light-var',
          parseInt(result[1], 16) +
          ',' +
          parseInt(result[2], 16) +
          ',' +
          parseInt(result[3], 16),
        ); 
      }
    } catch { }
    if (this.partner.PickupsColor && this.partner.PickupsColor.length > 0) {
      var result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(
        this.partner.PickupsColor,
      );
      document.documentElement.style.setProperty(
        '--pick-up-color-var',
        this.partner.PickupsColor,
      );
      document.documentElement.style.setProperty(
        '--pick-up-color-light-var',
        parseInt(result[1], 16) +
        ',' +
        parseInt(result[2], 16) +
        ',' +
        parseInt(result[3], 16),
      );
    }
    if (this.partner.BookedInColor && this.partner.BookedInColor.length > 0) {
      var result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(
        this.partner.BookedInColor,
      );
      document.documentElement.style.setProperty(
        '--booked-in-color-var',
        this.partner.BookedInColor,
      );
      document.documentElement.style.setProperty(
        '--booked-in-color-light-var',
        parseInt(result[1], 16) +
        ',' +
        parseInt(result[2], 16) +
        ',' +
        parseInt(result[3], 16),
      );
    }
    if (
      this.partner.WaitingForWorkColor &&
      this.partner.WaitingForWorkColor.length > 0
    ) {
      var result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(
        this.partner.WaitingForWorkColor,
      );
      document.documentElement.style.setProperty(
        '--assigned-to-technician-color-var',
        this.partner.WaitingForWorkColor,
      );
      document.documentElement.style.setProperty(
        '--assigned-to-technician-color-light-var',
        parseInt(result[1], 16) +
        ',' +
        parseInt(result[2], 16) +
        ',' +
        parseInt(result[3], 16),
      );
    }
    if (
      this.partner.WaitingForClientColor &&
      this.partner.WaitingForClientColor.length > 0
    ) {
      var result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(
        this.partner.WaitingForClientColor,
      );
      document.documentElement.style.setProperty(
        '--waiting-for-client-color-var',
        this.partner.WaitingForClientColor,
      );
      document.documentElement.style.setProperty(
        '--waiting-for-client-color-light-var',
        parseInt(result[1], 16) +
        ',' +
        parseInt(result[2], 16) +
        ',' +
        parseInt(result[3], 16),
      );
    }
    if (
      this.partner.WaitingForPartsColor &&
      this.partner.WaitingForPartsColor.length > 0
    ) {
      var result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(
        this.partner.WaitingForPartsColor,
      );
      document.documentElement.style.setProperty(
        '--waiting-for-parts-color-var',
        this.partner.WaitingForPartsColor,
      );
      document.documentElement.style.setProperty(
        '--waiting-for-parts-color-light-var',
        parseInt(result[1], 16) +
        ',' +
        parseInt(result[2], 16) +
        ',' +
        parseInt(result[3], 16),
      );
    }
    if (this.partner.WarrantyColor && this.partner.WarrantyColor.length > 0) {
      var result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(
        this.partner.WarrantyColor,
      );
      document.documentElement.style.setProperty(
        '--warranty-color-var',
        this.partner.WarrantyColor,
      );
      document.documentElement.style.setProperty(
        '--warranty-color-light-var',
        parseInt(result[1], 16) +
        ',' +
        parseInt(result[2], 16) +
        ',' +
        parseInt(result[3], 16),
      );
    }
    if (this.partner.WorkingOnColor && this.partner.WorkingOnColor.length > 0) {
      var result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(
        this.partner.WorkingOnColor,
      );
      document.documentElement.style.setProperty(
        '--started-working-var',
        this.partner.WorkingOnColor,
      );
      document.documentElement.style.setProperty(
        '--started-working-light-var',
        parseInt(result[1], 16) +
        ',' +
        parseInt(result[2], 16) +
        ',' +
        parseInt(result[3], 16),
      );
    }
    if (this.partner.BikeReadyColor && this.partner.BikeReadyColor.length > 0) {
      var result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(
        this.partner.BikeReadyColor,
      );
      document.documentElement.style.setProperty(
        '--ready-for-collection-color-var',
        this.partner.BikeReadyColor,
      );
      document.documentElement.style.setProperty(
        '--ready-for-collection-color-light-var',
        parseInt(result[1], 16) +
        ',' +
        parseInt(result[2], 16) +
        ',' +
        parseInt(result[3], 16),
      );
    }
    if (this.partner.CollectedColor && this.partner.CollectedColor.length > 0) {
      var result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(
        this.partner.CollectedColor,
      );
      document.documentElement.style.setProperty(
        '--collected-color-var',
        this.partner.CollectedColor,
      );
      document.documentElement.style.setProperty(
        '--collected-color-light-var',
        parseInt(result[1], 16) +
        ',' +
        parseInt(result[2], 16) +
        ',' +
        parseInt(result[3], 16),
      );
    }
    if (this.partner.DeliveryColor && this.partner.DeliveryColor.length > 0) {
      var result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(
        this.partner.DeliveryColor,
      );
      document.documentElement.style.setProperty(
        '--to-drop-off-color-var',
        this.partner.DeliveryColor,
      );
      document.documentElement.style.setProperty(
        '--to-drop-off-color-light-var',
        parseInt(result[1], 16) +
        ',' +
        parseInt(result[2], 16) +
        ',' +
        parseInt(result[3], 16),
      );
    }


    if (this.partner.Statuses !== undefined) {
      this.partner.CustomColourOne = this.partner.Statuses.find(x => x.StatusID == 21).Colour;
      this.partner.CustomColourTwo = this.partner.Statuses.find(x => x.StatusID == 22).Colour;
      this.partner.CustomColourThree = this.partner.Statuses.find(x => x.StatusID == 23).Colour;
      this.partner.CustomColourFour = this.partner.Statuses.find(x => x.StatusID == 24).Colour;
      this.partner.CustomColourFive = this.partner.Statuses.find(x => x.StatusID == 27).Colour;
      this.partner.CustomColourSix = this.partner.Statuses.find(x => x.StatusID == 28).Colour;
      this.partner.CustomColourSeven = this.partner.Statuses.find(x => x.StatusID == 29).Colour;
      this.partner.CustomColourEight = this.partner.Statuses.find(x => x.StatusID == 32).Colour;
      this.partner.CustomColourNine = this.partner.Statuses.find(x => x.StatusID == 33).Colour;
    }
    if (this.partner.CustomColourOne && this.partner.CustomColourOne.length > 0) {
      var result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(this.partner.CustomColourOne,);
      document.documentElement.style.setProperty('--custom-colour-one-var', this.partner.CustomColourOne,);
      document.documentElement.style.setProperty('--custom-colour-one-light-var', parseInt(result[1], 16) + ',' + parseInt(result[2], 16) + ',' + parseInt(result[3], 16),);
    }
    if (this.partner.CustomColourTwo && this.partner.CustomColourTwo.length > 0) {
      var result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(this.partner.CustomColourTwo,);
      document.documentElement.style.setProperty('--custom-colour-two-var', this.partner.CustomColourTwo,);
      document.documentElement.style.setProperty('--custom-colour-two-light-var', parseInt(result[1], 16) + ',' + parseInt(result[2], 16) + ',' + parseInt(result[3], 16),);
    }
    if (this.partner.CustomColourThree && this.partner.CustomColourThree.length > 0) {
      var result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(this.partner.CustomColourThree,);
      document.documentElement.style.setProperty('--custom-colour-three-var', this.partner.CustomColourThree,);
      document.documentElement.style.setProperty('--custom-colour-three-light-var', parseInt(result[1], 16) + ',' + parseInt(result[2], 16) + ',' + parseInt(result[3], 16),);
    }
    if (this.partner.CustomColourFour && this.partner.CustomColourFour.length > 0) {
      var result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(this.partner.CustomColourFour,);
      document.documentElement.style.setProperty('--custom-colour-four-var', this.partner.CustomColourFour,);
      document.documentElement.style.setProperty('--custom-colour-four-light-var', parseInt(result[1], 16) + ',' + parseInt(result[2], 16) + ',' + parseInt(result[3], 16),);
    }
    if (this.partner.CustomColourFive && this.partner.CustomColourFive.length > 0) {
      var result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(this.partner.CustomColourFive,);
      document.documentElement.style.setProperty('--custom-colour-five-var', this.partner.CustomColourFive,);
      document.documentElement.style.setProperty('--custom-colour-five-light-var', parseInt(result[1], 16) + ',' + parseInt(result[2], 16) + ',' + parseInt(result[3], 16),);
    }
    if (this.partner.CustomColourSix && this.partner.CustomColourSix.length > 0) {
      var result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(this.partner.CustomColourSix,);
      document.documentElement.style.setProperty('--custom-color-six-var', this.partner.CustomColourSix,);
      document.documentElement.style.setProperty('--custom-color-six-light-var', parseInt(result[1], 16) + ',' + parseInt(result[2], 16) + ',' + parseInt(result[3], 16),);
    }
    if (this.partner.CustomColourSeven && this.partner.CustomColourSeven.length > 0) {
      var result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(this.partner.CustomColourSeven,);
      document.documentElement.style.setProperty('--custom-colour-seven-var', this.partner.CustomColourSeven,);
      document.documentElement.style.setProperty('--custom-colour-seven-light-var', parseInt(result[1], 16) + ',' + parseInt(result[2], 16) + ',' + parseInt(result[3], 16),);
    }
    if (this.partner.CustomColourEight && this.partner.CustomColourEight.length > 0) {
      var result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(this.partner.CustomColourEight,);
      document.documentElement.style.setProperty('--custom-colour-eight-var', this.partner.CustomColourEight,);
      document.documentElement.style.setProperty('--custom-colour-eight-light-var', parseInt(result[1], 16) + ',' + parseInt(result[2], 16) + ',' + parseInt(result[3], 16),);
    }
    if (this.partner.CustomColourNine && this.partner.CustomColourNine.length > 0) {
      var result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(this.partner.CustomColourNine,);
      document.documentElement.style.setProperty('--custom-colour-nine-var', this.partner.CustomColourNine,);
      document.documentElement.style.setProperty('--custom-colour-nine-light-var', parseInt(result[1], 16) + ',' + parseInt(result[2], 16) + ',' + parseInt(result[3], 16),);
    }
  }

  logout() {
    this.helpersService.removeTokenAndLogout();
    this.router.navigateByUrl('/');
  }

  closeMenu() {
    if (!this.menuOpen) {
      this.menuOpen = !this.menuOpen;
    }
  }

  //Seems some customers may open new tabs and switch stores - need to refresh their screen so it shows the actual store they in.
  checkPartner() {
    if (this.mounted) {
      setTimeout(() => {
        if (
          this.mounted &&
          this.helpersService.getPartnerData() &&
          this.partner &&
          this.partner.ID !== undefined &&
          this.helpersService.getPartnerData().ID !== undefined &&
          this.helpersService.getPartnerData().ID !== this.partner.ID
        ) {
          window.location.reload();
        }
        this.checkPartner();
      }, 10000);
    }
  }

  updateNotificationBadge() {
    if (this.mounted) {
      this.notificationService
        .getUnreadNotifications(this.profile.PartnerID)
        .subscribe(
          (notifications) => {
            this.notifications = notifications.reverse().map((x) => {
              return { ...x, CreatedDate: x.CreatedDate + 'Z' };
            });
            this.getAvailableSMSCredits();
            setTimeout(() => {
              this.updateNotificationBadge();
            }, 120000);
          },
          (err) => {
            setTimeout(() => {
              this.updateNotificationBadge();
            }, 1200000);
          },
        );
    }
  }

  getAvailableSMSCredits() {
    this.notificationService
      .getAvailableSMSCredits(this.profile.PartnerID)
      .subscribe((credits) => {
        credits.forEach((element) => {
          if (element.MessageType === 'SMS') {
            this.credits = element.CreditsPurchased - element.CreditsUsed;
            if (this.credits >= 50) {
              this.helpersService.clearSMSMessageDisplayed();
            } else if (
              this.credits < 50 &&
              this.credits >= 0 &&
              !this.helpersService.getSMSMessageDisplayed()
            ) {
              setTimeout(() => {
                this.messageService.add({
                  life: 0,
                  sticky: true,
                  closable: true,
                  summary: this.translate.instant(
                    'bikeshop.general.low_sms_header',
                  ),
                  detail: this.translate.instant(
                    'bikeshop.general.low_sms_message',
                  ),
                });
                this.helpersService.setSMSMessageDisplayed();
              }, 1000);
            }
          }
        });
      });
  }

  productWebHook() {
    //if (this.mounted) {
    //  this.partnerService.getWorkToDo(this.helpersService.getPartnerId()).subscribe(worktodo => {
    //    if (worktodo.length > 0) {
    //      this.productsService
    //        .getAllProductsWithGear(this.helpersService.getPartnerId())
    //        .subscribe((products) => {
    //          this.helpersService.saveProductData(products);
    //          setTimeout(() => {
    //            this.productWebHook();
    //          }, 60000);
    //        }, err => {
    //          setTimeout(() => {
    //            this.productWebHook();
    //          }, 60000);
    //        });
    //    } else {
    //      setTimeout(() => {
    //        this.productWebHook();
    //      }, 60000);
    //    }
    //  }, err => {
    //    setTimeout(() => {
    //      this.productWebHook();
    //    }, 60000);
    //  });
    //}
  }

  actionMessage(notification) {

    this.notificationOpen = false;
    this.dismissMessage(notification);
    if (notification.JobCardID) {

      if (this.partner.UseNewJobCard) {
        this.newJobcardService.openManageJobCard(notification.JobCardID, {
          onRefreshEvents: () => { }
        }, true);

        return;
      }

      this.serviceRequest
        .getServiceRequestData(notification.JobCardID)
        .subscribe((jobcard) => {
          const modalRef = this.modalService.open(UpdateJobcardComponent, {
            size: 'lg',
            backdrop: 'static',
            windowClass: 'jobcard-modal',
          });
          modalRef.componentInstance.jobcard = jobcard;
          modalRef.componentInstance.partnerID = this.profile.PartnerID;
          modalRef.componentInstance.goToMessaging = true;
          modalRef.result.then(
            (result) => { },
            (onrejected) => { },
          );
        });
    } else if (notification.ReservationID) {
      this.rentalsService
        .getRentalReservation(this.partner.ID, notification.ReservationID)
        .subscribe((reservation) => {
          this.selectedReservation = reservation;
          this.showRentalReservation = true;
        });
    }
  }

  dismissMessage(notification) {
    var index = this.notifications.indexOf(notification);
    if (index > -1) {
      this.notifications.splice(index, 1);
    }

    this.notificationService
      .markMessageRead(this.profile.PartnerID, notification.ID)
      .subscribe((result) => { });
  }

  setPrinter() {
    this.dropMenuOpen = false;
    this.confirmationService.confirm({
      key: 'bikeshop_main',
      message: this.translate.instant('general.printer_setup_message'),
      header: this.translate.instant('general.printer_setup'),
      acceptLabel: this.translate.instant('general.a4'),
      rejectLabel: this.translate.instant('general.receipt_printer'),
      accept: () => {
        this.helpersService.setPrinterType('A4');
      },
      reject: () => {
        this.helpersService.setPrinterType('ReceiptPrinter');
      },
    });
  }

  private statusKey(partnerId, product) {
    return partnerId + '|' + product;
  }

  private currentKey() {
    return this.statusKey(
      this.helpersService.getPartnerId(),
      this.activeProduct,
    );
  }

  private isPaymentStatusCurrent() {
    return (
      this.paymentStatusKey !== null &&
      this.paymentStatusKey === this.currentKey()
    );
  }

  private invalidatePaymentStatus() {
    this.paymentStatusKey = null;
  }

  //ProductType comes back PascalCase from getPartnerDetail but camelCase from some
  //other endpoints (see wizard-users.component.ts), so accept either.
  private productRows() {
    return ((this.partner && this.partner.SubscribedProducts) || [])
      .map((r) => {
        return {
          type: (r.ProductType || r.productType || '').toUpperCase(),
          statusID: r.StatusID,
        };
      })
      .filter((r) => {
        return r.type === WORKSHOP || r.type === RENTALS;
      });
  }

  //"Does the store have this product at all" - ANY status, deliberately unfiltered.
  //The API fabricates statusID 2 when the subscription row is missing, so this is the
  //only way to tell "never had it" from "trial genuinely expired".
  private ownsProduct(product: string) {
    return (
      this.productRows().filter((r) => {
        return r.type === product;
      }).length > 0
    );
  }

  //StatusID straight off the store's own subscription row, or null if it has no row for
  //that product. Independent of the fetched payment status, so it is correct on first
  //paint and survives a response being dropped as stale or failing outright.
  private productStatus(product: string): number {
    const row = this.productRows().filter((r) => {
      return r.type === product;
    })[0];
    return row ? row.statusID : null;
  }

  //The i18n keys under bikeshop.payment.* are the lowercased PartnerStatus enum names,
  //which is how getPaymentStatus() builds them from the API's `status` string.
  private readonly STATUS_NAMES = {
    1: 'trialinprogress',
    2: 'trialexpired',
    3: 'paymentmissed',
    4: 'paymentmethodexpired',
    20: 'cancellationinprogress',
    21: 'cancelled',
    50: 'subscriptionactive',
    51: 'demoaccount',
  };

  //The banner template also requires paymentStatus.message, so the flag alone isn't
  //enough - without text it stays invisible. Fill it from the store's own row when we
  //have no fetched status for the current vertical, which is why an expired rentals-only
  //store was silent. Only the statuses whose strings need no date interpolation.
  private setBannerFromRow() {
    const status = this.productStatus(this.activeProduct);
    if (this.isPaymentStatusCurrent() || [2, 3, 4, 21].indexOf(status) === -1) {
      return;
    }
    this.paymentStatus = this.paymentStatus || {};
    this.paymentStatus.message = this.translate.instant(
      'bikeshop.payment.' + this.STATUS_NAMES[status],
    );
    this.paymentStatus.secondaryMessage = this.translate.instant(
      status === 2
        ? 'bikeshop.payment.click_here_to_subscribe'
        : 'bikeshop.payment.click_here_to_manage_your_account',
    );
    //Deliberately NOT setting paymentStatusKey - this is presentational only. The
    //access gate must keep requiring a genuinely fetched status or it would start
    //gating on partner-detail data and lose the fail-open guarantee.
  }

  //"Is this product usable" - the question the existing [1,3,4,20,50,51] filter asks.
  private usableProducts(): string[] {
    return this.productRows()
      .filter((r) => {
        return this.USABLE_STATUSES.indexOf(r.statusID) > -1;
      })
      .map((r) => {
        return r.type;
      });
  }

  getPaymentStatus() {
    const partnerId = this.helpersService.getPartnerId();
    const product = this.activeProduct;
    const key = this.statusKey(partnerId, product);
    //We no longer know the status for the current pair - fail open until we do.
    this.invalidatePaymentStatus();

    this.paymentService
      .getPaymentStatusV2(partnerId, product)
      .subscribe({
        next: (paymentStatus) => {
        //The store or vertical changed while this was in flight - drop it.
        if (key !== this.currentKey()) {
          return;
        }
        //GetPaymentStatusV2 returns 200 with an empty string when the partner is
        //not found; that must not read as "blocked".
        if (!paymentStatus || typeof paymentStatus.statusID !== 'number') {
          return;
        }
        this.paymentStatus = paymentStatus;
        this.paymentStatusKey = key;
        if (paymentStatus.status) {
          this.paymentStatus.message = this.translate.instant(
            'bikeshop.payment.' + paymentStatus.status.toLowerCase(),
            {
              lastDate: moment(paymentStatus.nextPaymentDate).format(
                'DD MMM YYYY',
              ),
              days: moment(paymentStatus.trialEnds).fromNow(),
            },
          );
          this.paymentStatus.secondaryMessage =
            [1, 2, 22].indexOf(paymentStatus.statusID) > -1
              ? this.translate.instant(
                'bikeshop.payment.click_here_to_subscribe',
              )
              : this.translate.instant(
                'bikeshop.payment.click_here_to_manage_your_account',
              );
        }
        this.helpersService.savePaymentStatus(paymentStatus);
        this.routeToPricing(this.router.url);
        },
        //Leave the key null: an unknown status must fail open, not lock the user out.
        error: () => { },
      });
  }

  showPaymentStatusWarning() {
    //Driven off the store's own subscription row rather than the fetched status, so it
    //can't be lost when a response is dropped as stale - which is how an expired
    //rentals-only store ended up showing nothing at all.
    const status = this.productStatus(this.activeProduct);
    //No row for this product, so there is nothing to warn about. The API would have
    //fabricated a statusID 2 here, which is exactly what we must not act on.
    if (status === null) {
      return false;
    }
    //These need no date, so the row alone is enough.
    if ([2, 3, 4, 21].indexOf(status) > -1) {
      return true;
    }
    //TrialInProgress and CancellationInProgress need TrialEnds / nextPaymentDate, and
    //partner detail doesn't return either - fall back to the fetched status for those.
    if (status === 1 || status === 20) {
      if (!this.isPaymentStatusCurrent()) {
        return false;
      }
      if (status === 20) {
        return true;
      }
      return (
        moment(this.paymentStatus.trialEnds).subtract(10, 'days') <= moment()
      );
    }
    return false;
  }

  allowSystemAccess() {
    //Demo accounts always have access.
    if (this.partner && this.partner.StatusID === 51) {
      return true;
    }
    //No authoritative status for the CURRENT (partner, product) pair yet - allow.
    //getPaymentStatus() re-runs routeToPricing() once the real answer lands, so a
    //genuinely expired user is redirected a moment later. Failing closed here
    //instead would lock out paying customers mid-switch.
    if (!this.isPaymentStatusCurrent()) {
      return true;
    }
    //The store has no subscription row for this product, so the statusID 2 the API
    //returned is fabricated, not evidence. "Nothing" must not mean "blocked".
    if (!this.ownsProduct(this.activeProduct)) {
      return true;
    }
    return (
      this.paymentStatus.statusID !== 21 && this.paymentStatus.statusID !== 2
    );
  }

  getSubscriptionURL() {
    if (window.location.pathname.indexOf('/store/rentals') > -1) {
      return '/store/rentals/manage-subscription';
    }
    if (window.location.pathname.indexOf('/store') > -1) {
      return '/store/manage-subscription';
    }
  }

  routeToPricing(url) {
    if (
      url.indexOf('/store') > -1 &&
      [
        '/store/calendar',
        '/store/collections',
        '/store/services/open',
        '/store/community',
        '/store/insurance',
        '/store/purchase-messaging-bundle',
        '/store/service-types',
        '/store/user-management',
        '/store/pick-ups-delivery-setup',
      ].indexOf(url) > -1 &&
      !this.allowSystemAccess()
    ) {
      this.router.navigateByUrl('/store/manage-subscription');
    }
    if (
      url.indexOf('/store/rentals') > -1 &&
      [
        '/store/rentals/reservations',
        '/store/rentals/reservations-summary',
      ].indexOf(url) > -1 &&
      !this.allowSystemAccess()
    ) {
      this.router.navigateByUrl('/store/rentals/manage-subscription');
    }
  }

  openAllNotifications() {
    this.notificationOpen = false;
    this.router.navigateByUrl('/store/job-card-messages');
  }

  initiateSubscriptionServices() {
    if (!this.IsDev) {
      navigator.serviceWorker.register('custom-service-worker.js');
      navigator.serviceWorker.ready.then((serviceWorkerRegistration) => {
        this.serviceWorkerRegistration = serviceWorkerRegistration;

        if (this.serviceWorkerRegistration.pushManager) {
          this.serviceWorkerRegistration.pushManager.getSubscription().then(
            (subscription) => {
              this.canSubscribeToNotifications = true;
              if (subscription && subscription.endpoint) {
                this.notificationService
                  .checkBrowserNotificationSubscription(subscription.endpoint)
                  .subscribe(
                    (result) => {
                      this.hasActiveSubscription = true;
                    },
                    (err) => {
                      this.hasActiveSubscription = false;
                    },
                  );
              } else {
                this.hasActiveSubscription = false;
              }
            },
            (err) => { },
          );
        }
      });
    }
  }

  subscribeToPushNotifications() {
    var vapid_public_key = this.appConfig.getVapidPublicKey();

    var options = {
      userVisibleOnly: true,
      applicationServerKey: vapid_public_key,
    };
    this.serviceWorkerRegistration.pushManager.subscribe(options).then(
      (pushSubscription) => {
        this.notificationService
          .subscribeToBrowserNotifications(pushSubscription)
          .subscribe((res) => {
            this.hasActiveSubscription = true;
          });
      },
      function (error) { },
    );
  }

  unsubscribeFromPushNotifications() {
    this.serviceWorkerRegistration.pushManager
      .getSubscription()
      .then((subscription) => {
        subscription.unsubscribe().then((result) => {
          this.notificationService
            .unsubscribeFromBrowserNotifications(subscription)
            .subscribe((res) => {
              this.hasActiveSubscription = false;
            });
        });
      });
  }

  activateWorkshop() {
    if (this.activeProduct !== WORKSHOP) {
      var lastURL = this.helpersService.getLastURL();
      this.helpersService.setLastURL(this.router.url.toLocaleLowerCase());
      if (this.profile.isAdmin || this.profile.isManager) {
        this.menuItems = this.shopAdminServiceMenuItems;
      } else if (this.profile.isServiceLead) {
        this.menuItems = this.serviceLeadServiceMenuItems;
      } else if (this.profile.isShopRideAdmin) {
        this.menuItems = this.shopRideAdminMenuItems;
      } else if (this.profile.isTechnician) {
        this.menuItems = this.technicianServiceMenuItems;
      }
      this.activeProduct = WORKSHOP;
      console.log(lastURL);
      this.router.navigateByUrl(
        lastURL === null ||
          lastURL === undefined ||
          lastURL === 'null' ||
          lastURL.indexOf('/rentals/') > -1
          ? 'store/calendar'
          : lastURL,
      );
      this.helpersService.setActiveProduct(this.activeProduct);
      this.getPaymentStatus();
    }
  }

  activateRentals() {
    if (this.activeProduct !== RENTALS) {
      var lastURL = this.helpersService.getLastURL();
      this.helpersService.setLastURL(this.router.url.toLocaleLowerCase());
      this.menuItems = this.shopAdminRentalMenuItems;
      this.activeProduct = RENTALS;
      console.log(lastURL);
      this.router.navigateByUrl(
        lastURL === null ||
          lastURL === undefined ||
          lastURL === 'null' ||
          lastURL.indexOf('/rentals/') == -1
          ? 'store/rentals/reservations-summary'
          : lastURL,
      );
      this.helpersService.setActiveProduct(this.activeProduct);
      this.getPaymentStatus();
      this.getRentalServiceIndicatorsDue(true);
    }
  }

  openHelpDesk() {
    (window as any).HubSpotConversations?.widget.load();
    (window as any).HubSpotConversations?.widget.open();

    (window as any).HubSpotConversations.on('widgetClosed', (event) => {
      this.hideDefaultChatButton();
    });

  }

  hideDefaultChatButton() {
    (window as any).HubSpotConversations?.widget.remove();
  }

  initializeHelpDesk() {
    (window as any).hsConversationsSettings = {
      loadImmediately: false,
    };

  }



  openHelpVideos() {
    if (!this.shopDropMenuOpenNew) {
      window.open('https://help.hubtiger.com/', '_blank');
    }
  }

  helpSubMenu = false;


  openReferrals() {
    if (!this.shopDropMenuOpenNew) {
      window.open(
        'https://hubtiger.referral-factory.com/JLZhSV/join',
        '_blank',
      );
    }
  }

  checkIfTextMessagePlatformConfigured() {
    this.communicationService.getConfiguredTextMessagePlatformForPartner(this.helpersService.getPartnerId()).subscribe(res => {
      this.connectedPlatform = res.textPlatformSystemId;
      console.log(this.connectedPlatform);
      if (this.connectedPlatform > 0) { this.isConnectedToTextPlatform = true; this.credits = 0; }
    });
  }

  private rentalServiceIndicatorsTimeout: any = null;
  getRentalServiceIndicatorsDue(allowReload: boolean = false) {
    // Clear any existing timeout to prevent multiple loops
    if (this.rentalServiceIndicatorsTimeout) {
      clearTimeout(this.rentalServiceIndicatorsTimeout);
      this.rentalServiceIndicatorsTimeout = null;
    }

    if (
      this.router.url.toLocaleLowerCase().indexOf('/rentals/') > -1 ||
      this.activeProduct === RENTALS
    ) {
      this.rentalsService
        .getServiceIndicatorDueForServiceCount(this.helpersService.getPartnerId())
        .subscribe((response) => {
          this.serviceIndicatorsDue =
            response && response.indicatorsDueForService
              ? response.indicatorsDueForService
              : 0;
          this.showServiceIndicatorsDue = this.serviceIndicatorsDue > 0;
          // Update menu item as before...
          const indicatorMenu = this.shopAdminRentalMenuItems.find(
            (item) => item.classId === 'menu-service-indicator-dashboard'
          );
          if (indicatorMenu) {
            indicatorMenu.serviceIndicatorsDue = this.serviceIndicatorsDue;
            indicatorMenu.showServiceIndicatorsDue = this.showServiceIndicatorsDue;
          }
        });

      if (allowReload) {
        this.rentalServiceIndicatorsTimeout = setTimeout(() => {
          this.getRentalServiceIndicatorsDue(true);
        }, 300000);
      }
    }
  }

  async refreshGigyaRoles() {
    const isGigyaUser = localStorage.getItem('gigya_sso') === 'true';

    if (isGigyaUser) {
      this.authenticationService.refreshRolesFromGigya().subscribe(async (result) => {
        if (result?.rolesUpdated) {
          await this.getUpdatedUserProfile();
          console.log('Profile after', this.profile);
          if(!this.profile.UserRoles.map(x=> {return x.PartnerID}).includes(this.profile.PartnerID)){
            this.selectShop({ID: this.profile.UserRoles.find(x=> x.PartnerID > 0).PartnerID})
          }          
        }
      });
    }
  }

  isShopRideAdminOnly(){
    return this.profile.UserRoles.some(x=> x.RoleID === 10) && !this.profile.UserRoles.some(x=> x.RoleID === 1 || x.RoleID === 2 || x.RoleID === 3 || x.RoleID === 9);
  }


  protected readonly event = event;
}
